<div class="calendar-container">
    <h1>{{ "calendar.title_full" | translate }}</h1>

    <div class="calendar-chips">
      <button
        type="button"
        class="legend-item"
        [class.inactive]="!typeFilter.wedding"
        [attr.aria-pressed]="typeFilter.wedding"
        (click)="toggleTypeFilter('wedding')"
      >
        <span class="legend-dot legend-dot-wedding"></span>
        {{ "calendar.legend.wedding" | translate }}
      </button>
      <button
        type="button"
        class="legend-item"
        [class.inactive]="!typeFilter.test"
        [attr.aria-pressed]="typeFilter.test"
        (click)="toggleTypeFilter('test')"
      >
        <span class="legend-dot legend-dot-test"></span>
        {{ trialLabelKey | translate }}
      </button>
      <span class="kpi-chip">
        <app-icon name="calendar" [size]="14"></app-icon>
        {{ "calendar.kpi.month_count" | translate: { count: kpiMonthCount } }}
      </span>
      <span class="kpi-chip">
        <app-icon name="clock" [size]="14"></app-icon>
        {{ kpiNextLabel }}
      </span>
    </div>
    <p class="calendar-legend-hint">{{ "calendar.legend.hint" | translate }}</p>

    <app-load-error *ngIf="eventsError" (retry)="loadCalendarData()"></app-load-error>

    <!-- ===== MOBILE: mese a puntini + agenda ===== -->
    <ng-container *ngIf="isMobile; else desktopCalendar">
      <div class="m-toolbar">
        <button type="button" class="m-nav" (click)="shiftMonth(-1)" [attr.aria-label]="'calendar.m.prev' | translate">‹</button>
        <span class="m-title">{{ monthTitle }}</span>
        <button type="button" class="m-nav" (click)="shiftMonth(1)" [attr.aria-label]="'calendar.m.next' | translate">›</button>
        <button type="button" class="m-today" (click)="goToday()">{{ "calendar.m.today" | translate }}</button>
      </div>

      <div class="m-switch" role="tablist">
        <button type="button" role="tab" [class.active]="mobileView === 'month'" (click)="mobileView = 'month'">
          {{ "calendar.m.month" | translate }}
        </button>
        <button type="button" role="tab" [class.active]="mobileView === 'upcoming'" (click)="mobileView = 'upcoming'">
          {{ "calendar.m.upcoming" | translate }}
        </button>
      </div>

      <ng-container *ngIf="mobileView === 'month'">
        <div class="m-grid" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
          <span class="m-dow" *ngFor="let d of weekdayLabels">{{ d }}</span>
          <button
            type="button"
            class="m-day"
            *ngFor="let c of monthCells"
            [class.out]="!c.inMonth"
            [class.today]="c.isToday"
            [class.selected]="c.date === selectedDate"
            (click)="selectDate(c.date)"
          >
            <span class="m-day-num">{{ c.day }}</span>
            <span class="m-dots">
              <span class="m-dot wedding" *ngIf="c.hasWedding"></span>
              <span class="m-dot test" *ngIf="c.hasTest"></span>
            </span>
          </button>
        </div>

        <div class="m-agenda">
          <div class="m-agenda-head">
            <span class="m-agenda-title">{{ selectedLabel }}</span>
            <button type="button" class="m-add" (click)="openQuickCreateFor(selectedDate)">
              <app-icon name="plus" [size]="15"></app-icon>
              {{ "calendar.m.new" | translate }}
            </button>
          </div>
          <ng-container *ngFor="let it of selectedItems">
            <ng-container *ngTemplateOutlet="itemRow; context: { $implicit: it }"></ng-container>
          </ng-container>
          <p class="m-empty" *ngIf="!eventsError && !selectedItems.length">{{ "calendar.m.no_events_day" | translate }}</p>
        </div>
      </ng-container>

      <div class="m-upcoming" *ngIf="mobileView === 'upcoming'">
        <div class="m-group" *ngFor="let g of upcomingGroups">
          <p class="m-group-label">{{ g.label }}</p>
          <ng-container *ngFor="let it of g.items">
            <ng-container *ngTemplateOutlet="itemRow; context: { $implicit: it }"></ng-container>
          </ng-container>
        </div>
        <p class="m-empty" *ngIf="!eventsError && !upcomingGroups.length">{{ "calendar.m.no_upcoming" | translate }}</p>
      </div>

      <ng-template #itemRow let-it>
        <button type="button" class="m-item" [class.test]="it.type === 'test'" (click)="openSheet(it)">
          <span class="m-item-bar"></span>
          <span class="m-item-main">
            <span class="m-item-title">{{ it.name }}</span>
            <span class="m-item-sub">
              {{ itemLabelKey(it) | translate }}<ng-container *ngIf="it.time"> · {{ it.time }}</ng-container><ng-container *ngIf="it.location"> · {{ it.location }}</ng-container>
            </span>
          </span>
          <span class="m-item-weather" *ngIf="it.weatherIcon">{{ it.weatherIcon }} {{ it.weather.temp_max | number: "1.0-0" }}°</span>
        </button>
      </ng-template>
    </ng-container>

    <ng-template #desktopCalendar>
      <full-calendar [options]="calendarOptions"></full-calendar>
    </ng-template>

    <div class="reminders-card">
      <button type="button" class="reminders-head" (click)="remindersOpen = !remindersOpen" [attr.aria-expanded]="remindersOpen">
        <h3 class="reminders-title">{{ "calendar.reminders.title" | translate }}</h3>
        <span class="reminders-count" *ngIf="openRemindersCount">{{ openRemindersCount }}</span>
        <span class="reminders-chevron" [class.open]="remindersOpen">▾</span>
      </button>
      <app-load-error *ngIf="remindersOpen && remindersError" (retry)="loadReminders()"></app-load-error>
      <ng-container *ngIf="remindersOpen && !remindersError">
        <div class="reminders-list">
          <label class="reminder-item" *ngFor="let r of reminders" [class.done]="r.done">
            <input type="checkbox" [checked]="r.done" (change)="toggleReminder(r)" />
            <span class="reminder-text">{{ r.text }}</span>
            <button
              type="button"
              class="reminder-remove"
              (click)="removeReminder(r)"
              [attr.aria-label]="'calendar.reminders.remove' | translate"
            >
              ×
            </button>
          </label>
          <p class="reminders-empty" *ngIf="!reminders.length">
            {{ "calendar.reminders.empty" | translate }}
          </p>
        </div>
        <form class="reminders-add" (ngSubmit)="addReminder()">
          <input
            type="text"
            [(ngModel)]="newReminderText"
            name="newReminderText"
            [placeholder]="'calendar.reminders.placeholder' | translate"
          />
          <button type="submit" [disabled]="!newReminderText.trim()" [attr.aria-label]="'calendar.reminders.add' | translate">+</button>
        </form>
      </ng-container>
    </div>

    <!-- CREAZIONE RAPIDA (popover su desktop, pannello dal basso su mobile) -->
    <div
      class="quick-create-backdrop"
      [class.dim]="isMobile"
      *ngIf="quickCreate.open"
      (click)="closeQuickCreate()"
    ></div>
    <form
      class="quick-create-popover"
      [class.as-sheet]="isMobile"
      *ngIf="quickCreate.open"
      [style.top.px]="isMobile ? null : quickCreate.top"
      [style.left.px]="isMobile ? null : quickCreate.left"
      (ngSubmit)="submitQuickCreate()"
      (click)="$event.stopPropagation()"
    >
      <span class="quick-create-date">{{ quickCreate.dateLabel }}</span>
      <input
        type="text"
        class="quick-create-input"
        [(ngModel)]="quickCreate.name"
        name="quickCreateName"
        [placeholder]="'calendar.quick_create.placeholder' | translate"
        autofocus
      />
      <div class="quick-create-actions">
        <button type="button" class="quick-create-cancel" (click)="closeQuickCreate()">
          {{ "calendar.quick_create.cancel" | translate }}
        </button>
        <button type="submit" class="quick-create-submit" [disabled]="!quickCreate.name.trim()">
          {{ "calendar.quick_create.create" | translate }}
        </button>
      </div>
    </form>

    <!-- RIEPILOGO EVENTO (mobile) -->
    <div class="sheet-backdrop" *ngIf="sheetItem" (click)="closeSheet()"></div>
    <div class="sheet" *ngIf="sheetItem as it" role="dialog" aria-modal="true">
      <span class="sheet-handle"></span>
      <p class="sheet-type" [class.test]="it.type === 'test'">{{ itemLabelKey(it) | translate }}</p>
      <h3 class="sheet-title">{{ it.name }}</h3>
      <p class="sheet-line">
        <app-icon name="calendar" [size]="16"></app-icon>
        {{ sheetDateLabel(it) }}<ng-container *ngIf="it.time"> · {{ it.time }}</ng-container>
      </p>
      <p class="sheet-line" *ngIf="it.location">
        <app-icon name="pin" [size]="16"></app-icon>
        {{ it.location }}
      </p>
      <p class="sheet-line" *ngIf="it.weather">
        <span class="sheet-weather">{{ it.weatherIcon }}</span>
        {{ it.weatherTip }} ({{ it.weather.temp_max | number: "1.0-0" }}°/{{ it.weather.temp_min | number: "1.0-0" }}°)
      </p>
      <div class="sheet-pills">
        <span class="sheet-pill" [class.ok]="it.contract_signed">
          {{ (it.contract_signed ? "calendar.modal.contract_signed" : "calendar.modal.contract_pending") | translate }}
        </span>
        <span class="sheet-pill" [class.ok]="it.deposit_paid">
          {{ (it.deposit_paid ? "calendar.modal.deposit_paid" : "calendar.modal.deposit_pending") | translate }}
        </span>
      </div>
      <div class="sheet-actions">
        <button type="button" class="sheet-action" *ngIf="it.location" (click)="openDirections(it.location)">
          <app-icon name="navigate"></app-icon>
          {{ "riepilogo.hero.directions" | translate }}
        </button>
        <a class="sheet-action" *ngIf="it.phone" [href]="'tel:' + it.phone">
          <app-icon name="phone"></app-icon>
          {{ "riepilogo.hero.call" | translate }}
        </a>
      </div>
      <button type="button" class="btn-gold sheet-open" (click)="openEvent(it.id)">
        {{ "calendar.modal.open_event" | translate }}
      </button>
    </div>
  </div>
